var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"colors-list"},[_c('ul',_vm._l((_vm.colors),function(color,index){return _c('li',{key:index,on:{"click":function($event){return _vm.$emit('changeColor', color.id)}}},[_c('ColorPickUi',{attrs:{"is_checked":color.id === _vm.active_color_id,"color":color.color}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }